import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {AgendaCategory} from '../entity/agendaCategory.model';
import {EntityLinkedToAccountWithAuditMetadataConverter} from '../../../../../common/converter/entityLinkedToAccountWithAuditMetadata.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {
    OnlineFormFormDefinitionSummaryConverter
} from '../../../../../online-form/definition/api/entity/converter/onlineFormFormDefinitionSummary.converter';
import {AgendaCategorySummaryModel} from "../entity/agendaCategorySummary.model";

@Injectable({
    providedIn: 'root'
})
export class AgendaCategorySummaryConverter extends HttpModelConverter<AgendaCategorySummaryModel> {

    constructor() {
        super();
    }
    protected createInstance(): AgendaCategorySummaryModel {
        return new AgendaCategorySummaryModel();
    }


    protected enrichObject(result: AgendaCategorySummaryModel, src: AgendaCategorySummaryModel) {
    }
}
